import { currentUser } from "@/App";
import LiveCommentsContainer from "@/components/Comments/LiveCommentsContainer";
import { useBroadcast } from "@/services/hooks";
import { Groups } from "@mui/icons-material";
import { Box, Container, Stack, Typography } from "@mui/material";
import { useEffect } from "react";
import { useSearchParams, useParams } from "react-router-dom";
import ToggleTipSwitch from "@/components/ToggleTipSwitch";
import Broadcaster from "./Broadcaster";
import Viewer from "./Viewer";

export default function LiveContainer() {
  const { artistKey } = useParams();
  const [searchParams] = useSearchParams();
  const key = searchParams.get("key");

  const { data: broadcast } = useBroadcast(key);

  useEffect(() => {
    if (broadcast?.status === "stopped") {
      alert("Broadcast has ended.");
      window.location.href = "/";
    }
  }, [broadcast]);

  return (
    <Container maxWidth="sm">
      {/* if its an artist, show viewer count */}
      {currentUser.key === artistKey ? (
        <>
          <Broadcaster status={broadcast?.status} />
          <ViewerCountContainer viewerCount={broadcast?.viewer_count} />
        </>
      ) : (
        <Viewer />
      )}

      <LiveCommentsContainer
        content={broadcast?.content}
        background="#121212"
      />
    </Container>
  );
}

function ViewerCountContainer({ viewerCount }) {
  return (
    <Box
      sx={{
        display: "flex",
        mt: 2,
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      {/* <CopyArtistLink /> */}
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Groups sx={{ mx: 1 }} color="primary" />
        <Typography variant="body1" color="textSecondary" sx={{ mx: 1 }}>
          {viewerCount || 0}
        </Typography>
      </Box>
      {/* <ToggleTipSwitch /> */}
    </Box>
  );
}
